import { render, staticRenderFns } from "./shipping.vue?vue&type=template&id=5ecc5e70&scoped=true"
import script from "./shipping.vue?vue&type=script&lang=js"
export * from "./shipping.vue?vue&type=script&lang=js"
import style0 from "./shipping.vue?vue&type=style&index=0&id=5ecc5e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc5e70",
  null
  
)

export default component.exports